class NotifyMeModal {
  constructor() {
    this.modal = document.getElementById('NotifyMeModal');
    this.overlay = document.getElementById('NotifyMeModalOverlay');
    this.closeBtn = document.querySelector('.notify-me-modal__close');
    this.form = document.getElementById('notify-me-modal-form');
    this.successState = document.querySelector('.notify-me-modal__success');
    this.continueBtn = document.querySelector('.notify-me-modal__continue');

    if (!this.modal || !this.overlay) return;

    this.init();
  }

  init() {
    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.continueBtn?.addEventListener('click', () => this.close());

    if (this.form && typeof handleKlaviyoInteractions === 'function') {
      handleKlaviyoInteractions({
        formSelector: '#notify-me-modal-form',
        customSource: 'Product Back-in-Stock Modal',
        onSuccess: () => {
          this.showSuccess();
        },
        onError: (error) => {
          console.error('Klaviyo submission error:', error);
        },
      });
    } else if (this.form) {
      console.warn(
        'handleKlaviyoInteractions not found. Make sure klaviyo.js is loaded.',
      );
    }
  }

  showSuccess() {
    if (this.form) {
      this.form.style.display = 'none';
    }

    if (this.successState) {
      this.successState.style.display = 'block';
    }

    setTimeout(() => {
      this.form?.reset();
    }, 1000);
  }

  open() {
    document.body.classList.add('notify-me-modal--show');
  }

  close() {
    document.body.classList.remove('notify-me-modal--show');

    setTimeout(() => {
      if (this.form) {
        this.form.style.display = 'flex';
        this.form.reset();
      }
      if (this.successState) {
        this.successState.style.display = 'none';
      }

      const klaviyoMessages = this.form?.querySelector('.klaviyo_messages');
      if (klaviyoMessages) {
        klaviyoMessages.style.display = 'none';
        const successMessage = klaviyoMessages.querySelector('.success_message');
        const errorMessage = klaviyoMessages.querySelector('.error_message');
        if (successMessage) successMessage.style.display = 'none';
        if (errorMessage) errorMessage.style.display = 'none';
      }
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new NotifyMeModal();
});
